import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContractDelegation } from "../../Model/ServiceContractDelegation/ServiceContractDelegation";

export async function getServiceContractDelegation(id) {
    let response = await getAPIResponse("/v1/service-contract-delegation/" + id);
    if (response === null) {
        return null;
    }
    return ServiceContractDelegation.createFromResponseData(response);
}
